
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { HTTP } from "@/axios_api/http-common"
import EventBus from './../../eventBus'

@Component
export default class ColorSettings extends Vue {
    error: any = {
        generalMessage: '',
        errors: []
    }
    logo: string = ''
    activeScreen: string = 'main'
    successMessage: string = ''
    additionalSuccessMessage: string = ''
    loadingMessage: string = ''
    loadingTitle: string = ''
    view: string = 'company'
    fields: any[] = ['property', 'backgroundColor', 'action']
    contractorAndServicesFields: any[] = [
        { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
        { key: 'serial', label: 'S/N', sortable: false },
        'contractor', 'services', 'action']
    rigFields: any[] = [
        { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
        { key: 'serial', label: 'S/N', sortable: false },
        'propertyName', 'backgroundColor', 'action'
    ]
    wellFields: any[] = [
        { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" } },
        { key: 'serial', label: 'S/N', sortable: false },
        'propertyName', 'backgroundColor', 'action'
    ]
    activeItem: any = {}
    logoChanged: boolean = false
    loadingCompanyProfile: boolean = true
    companyProfile: any = {
        logoChanged: false,
        companyLogo: null,
        email: "",
        phoneNumber: "",
        companyName: "",
        country: "",
        state: "",
        address: ""
    }
    nptSettingsForm = {
        rootCause: "",
        associatedCause: ""
    }
    nptAssociatedCausesList = []
    showPreview: boolean = false
    uploadedPhoto!: any
    selectAllWellFluidTypes: boolean = false
    selectAllProjectClasses: boolean = false
    selectAllContractorAndServices: boolean = false
    selectAllRigTerrains: boolean = false
    selectedWellFluidRows: { name: string; id: string }[] = []
    selectedProjectClassRows: { name: string; id: string }[] = []
    selectedRigTerrainRows: { name: string; id: string }[] = []
    selectedContractorAndServicesRows: { name: string; id: string }[] = []
    deleteWellFluidTypePromptProperty: boolean = false
    deleteProjectClassPromptProperty: boolean = false
    deleteRigTerrainPromptProperty: boolean = false
    deleteContractorAndServicesPromptProperty: boolean = false


    get settingsRig() {
        return this.$store.getters['settingsModule/getSettingsRig']
    }
    get settingsWell() {
        return this.$store.getters['settingsModule/getSettingsWell']
    }
    get settingsProject() {
        return this.$store.getters['settingsModule/getSettingsProject'].sort((a: any, b: any) => {
            const itemA = (a.propertyName || '').toString().toLowerCase().trim();
            const itemB = (b.propertyName || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }
    get settingsTime() {
        return this.$store.getters['settingsModule/getTimeSettings']
    }
    get contractorAndServices() {
        return this.$store.getters['settingsModule/getContractorAndServices'].sort((a: any, b: any) => {
            const itemA = (a.contractor || '').toString().toLowerCase().trim();
            const itemB = (b.contractor || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }

    get settingsProjectBar() {
        return this.$store.getters['settingsModule/getProjectBarSettings']
    }

    get fetchColorSettings() {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }

    get fetchContractorAndServices() {
        return this.$store.dispatch('settingsModule/getContractorAndServices')
    }

    get allProjects() {
        return this.$store.getters['projectModule/getAllProjects']
    }

    disableTerrainDelete(item: any) {
        let foundTerrain = this.allProjects.find((project: any) => {
            if (project.rig && project.rig.terrain && project.rig.terrain != null) {
                return project.rig.terrain === item.propertyName
            }
            return null;
        })
        if (foundTerrain && foundTerrain !== '' && foundTerrain != null) {
            return true
        } else {
            return false
        }
    }

    disableWellFluidDelete(item: any) {
        let foundFluidType = this.allProjects.find((project: any) => {
            if (project.well && project.well.wellType && project.well.wellType != null) {
                return project.well.wellType === item.propertyName
            }
            return null
        })
        if (foundFluidType && foundFluidType !== '' && foundFluidType != null) {
            return true
        } else {
            return false
        }
    }

    disableProjectClassDelete(item: any) {
        let foundProjectClass = this.allProjects.find((project: any) => {
            if (project.projectClass && project.projectClass !== null) {
                return project.projectClass.name === item.propertyName
            }
            return null;
        })
        if (foundProjectClass && foundProjectClass !== '' && foundProjectClass != null) {
            return true
        } else {
            return false
        }
    }

    otherTabFunction(tabName: string) {
        this.view = tabName
    }

    editColor(data: any) {
        this.activeItem = data
        let modalColor = this.$refs.bvColor as any
        modalColor.show()
    }

    promptWellFluidTypeDelete(item: any) {
        this.activeItem = item;
        this.deleteWellFluidTypePromptProperty = true
    }

    promptProjectClassDelete(item: any) {
        this.activeItem = item;
        this.deleteProjectClassPromptProperty = true
    }

    promptContractorAndServicesDelete(item: any) {
        this.activeItem = item;
        this.deleteContractorAndServicesPromptProperty = true
    }

    promptRigTerrainDelete(item: any) {
        this.activeItem = item;
        this.deleteRigTerrainPromptProperty = true
    }

    toggleSelectAllWellFluidTypes() {
        if (!this.selectAllWellFluidTypes) {
            this.selectedWellFluidRows = this.settingsWell.map((wellSetting: any) => ({ id: wellSetting.id, name: wellSetting.propertyName }))
        } else {
            this.selectedWellFluidRows = []
        }
    }

    toggleSelectAllProjectClasses() {
        if (!this.selectAllProjectClasses) {
            this.selectedProjectClassRows = this.settingsProject.map((projectSetting: any) => ({ id: projectSetting.id, name: projectSetting.propertyName }))
        } else {
            this.selectedProjectClassRows = []
        }
    }

    toggleSelectAllContractorAndServices() {
        if (!this.selectAllContractorAndServices) {
            this.selectedContractorAndServicesRows = this.contractorAndServices.map((c: any) => ({ id: c.id, name: c.contractor }))
        } else {
            this.selectedContractorAndServicesRows = []
        }
    }

    toggleSelectAllRigTerrains() {
        if (!this.selectAllRigTerrains) {
            this.selectedRigTerrainRows = this.settingsRig.map((rig: any) => ({ id: rig.id, name: rig.propertyName }))
        } else {
            this.selectedRigTerrainRows = []
        }
    }

    select() {
        let modalColor = this.$refs.bvColor as any
        modalColor.hide()
        this.settingsRig.forEach((element: any) => {
            if (this.activeItem.property === element.property) {
                element.color = this.activeItem.color.hex
            }
        });
        this.settingsTime.forEach((element: any) => {
            if (this.activeItem.property === element.property) {
                element.color = this.activeItem.color.hex
            }
        });
        this.settingsWell.forEach((element: any) => {
            if (this.activeItem.property === element.property) {
                element.color = this.activeItem.color.hex
            }
        });
        this.settingsWell.forEach((element: any) => {
            if (this.activeItem.property === element.property) {
                element.color = this.activeItem.color.hex
            }
        });
    }

    editWellFluidType(fluid_id: number) {
        this.$router.push('/manage-well-fluid-type/?id=' + fluid_id.toString())
    }

    editProjectClass(id: number) {
        this.$router.push('/manage-project-class/?id=' + id.toString())
    }
    
    promptContractorAndServicesEdit(item: number) {
        this.$router.push('/manage-contractor-and-services/?id=' + item.toString())
    }

    editRigTerrain(id: number) {
        this.$router.push('/manage-rig-terrain/?id=' + id.toString())
    }

    async fileUploaded(e: any) {
        let file = e.target.files[0]
        this.logo = URL.createObjectURL(e.target.files[0])
        if (this.logo) {
            this.companyProfile.companyLogo = file
            this.companyProfile.logoChanged = true
        }
        let reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        this.showPreview = true;
        reader.onload = (e: any) => {
            const selectedImage = this.$refs.selectedImage as any
            selectedImage.setAttribute("src", e.target.result)
            this.uploadedPhoto = e.target.result
        }
    }

    removePhoto(e: any) {
        this.companyProfile.companyLogo = undefined;
        this.showPreview = false
        const selectedImage = this.$refs.selectedImage as any
        selectedImage.reset()
        this.uploadedPhoto = undefined
    }

    saveSettings() {
        this.activeScreen = 'loading'
        this.$eventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = 'Saving all settings'
        this.loadingTitle = 'Please wait...'
        this.$store.commit('settingsModule/setSettingsRig', this.settingsRig)
        this.$store.commit('settingsModule/setSettingsWell', this.settingsWell)
        this.$store.commit('settingsModule/setSettingsProject', this.settingsProject)
        this.$store.commit('settingsModule/setTimeSettings', this.settingsTime)
        setTimeout(() => {
            this.activeScreen = 'successNoBack'
            this.$eventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = 'Settings saved successfully'
            this.successMessage = 'Chart Settings Saved'
        }, 2000)
    }

    convertCompanyProfileToFormData(companyProfile: any) {
        let formData = new FormData();
        for (var key in companyProfile) {
            formData.append(key, companyProfile[key])
        }
        return formData
    }

    saveCompanyProfile() {
        this.loadingCompanyProfile = true;
        HTTP.post("appsettings/company-profile", this.convertCompanyProfileToFormData(this.companyProfile)).then(() => {
            this.loadingCompanyProfile = false
            this.$store.dispatch('settingsModule/getCompanyProfile')
        }).
            catch(() => {
                this.loadingCompanyProfile = false
            })
    }

    getWellFluidTypesToDelete() {
        const names = this.selectedWellFluidRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedWellFluidRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} well fluid type${remainingCount > 1 ? 's' : ''}`;
        }
    }

    getProjectClassToDelete() {
        const names = this.selectedProjectClassRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedProjectClassRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} project class${remainingCount > 1 ? 'es' : ''}`;
        }
    }

    getRigTerrainsToDelete() {
        const names = this.selectedRigTerrainRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedRigTerrainRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} project class${remainingCount > 1 ? 'es' : ''}`;
        }
    }

    getContractorAndServicesToDelete() {
        const names = this.selectedContractorAndServicesRows.map(row => row.name);

        let formattedNames = '';
        if (names.length <= 3) {
            const lastTwoNames = names.splice(-2);
            if (this.selectedContractorAndServicesRows.length === 2) {
                return formattedNames = `${names.join(', ')} ${lastTwoNames.join(' and ')}`;
            }
            return formattedNames = `${names.join(', ')}, ${lastTwoNames.join(' and ')}`;
        }
        else {
            const firstTwoNames = names.slice(0, 2);
            const remainingCount = names.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} Contractor & Services${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDeleteWellFluidTypes() {
        const isMultipleDelete = this.selectedWellFluidRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these well fluid types' : 'this well fluid type'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedWellFluidRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('settingsModule/deleteColorSettings', payload)
            .then((res: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These well fluid types' : 'This well fluid type'} will no longer be available`
                this.successMessage = `${isMultipleDelete ? this.getWellFluidTypesToDelete() : this.activeItem.propertyName} Deleted Successfully`
                this.deleteWellFluidTypePromptProperty = false
            })
            .catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deleteWellFluidTypePromptProperty = false
            })
    }

    doDeleteProjectClasses() {
        const isMultipleDelete = this.selectedProjectClassRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these project classes' : 'this project class'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedProjectClassRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('settingsModule/deleteColorSettings', payload)
            .then((res: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These project classes' : 'This project class'} will no longer be available`
                this.successMessage = `${isMultipleDelete ? this.getProjectClassToDelete() : this.activeItem.propertyName} Deleted Successfully`
                this.deleteProjectClassPromptProperty = false
            })
            .catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deleteProjectClassPromptProperty = false
            })
    }

    doDeleteContractorAndServices() {
        const isMultipleDelete = this.selectedContractorAndServicesRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these contractors/services' : 'this contractor service'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedContractorAndServicesRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('settingsModule/deleteContractorAndServices', payload)
            .then((res: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These contractors/services' : 'This contractor/service(s)'} will no longer be available`
                this.successMessage = `${isMultipleDelete ? this.getContractorAndServicesToDelete() : this.activeItem.contractor} Deleted Successfully`
                this.deleteContractorAndServicesPromptProperty = false
            })
            .catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deleteContractorAndServicesPromptProperty = false
            })
    }

    doDeleteRigTerrains() {
        const isMultipleDelete = this.selectedRigTerrainRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these rig terrains' : 'this rig terrain'}`
        this.loadingTitle = 'Deleting...'

        const payload = isMultipleDelete ? this.selectedRigTerrainRows.map(row => row.id) : [this.activeItem.id]
        this.$store.dispatch('settingsModule/deleteColorSettings', payload)
            .then((res: any) => {
                this.activeScreen = 'successNoBack'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = `${isMultipleDelete ? 'These rig terrains' : 'This rig terrain'} will no longer be available`
                this.successMessage = `${isMultipleDelete ? this.getRigTerrainsToDelete() : this.activeItem.propertyName} Deleted Successfully`
                this.deleteRigTerrainPromptProperty = false
            })
            .catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error.message
                this.deleteRigTerrainPromptProperty = false
            })
    }

    mounted() {
        this.fetchColorSettings;
        this.fetchContractorAndServices;
        this.$store.dispatch("projectModule/getAllProjects")
        HTTP.post("appsettings/keys", ["CompanyName", "Email", "PhoneNumber", "State", "Country", "Address", "CompanyLogo"]).then((res: any) => {
            this.companyProfile.companyName = res.data.data.CompanyName
            this.companyProfile.email = res.data.data.Email
            this.companyProfile.phoneNumber = res.data.data.PhoneNumber
            this.companyProfile.state = res.data.data.State
            this.companyProfile.country = res.data.data.Country
            this.companyProfile.address = res.data.data.Address
            this.showPreview = true
            this.uploadedPhoto = res.data.data.CompanyLogo
            this.loadingCompanyProfile = false
        }).
            catch(() => {
                this.loadingCompanyProfile = false
            })
    }
}
